import http from "../../http-common"

class SearchSortByOptionsService {
    getSortByOptions() {
        return http.get(`/search/order-by-options`)
    }  
}

export default new SearchSortByOptionsService();